import { ReactNode, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Inner = styled.div<{ $isVisible: boolean }>`
  opacity: 0;
  transform: translateY(3rem);
  transition: opacity 0.8s cubic-bezier(0.57, 0.61, 0, 0.97),
              transform 0.8s cubic-bezier(0.57, 0.61, 0, 0.97);

  ${({ $isVisible }) =>
    $isVisible &&
    `
      opacity: 1;
      transform: translateY(0);
    `}
`;

interface Props {
  threshold?: number;
  children: ReactNode;
}

const FadeInOnScroll = ({ threshold = 0.2, children }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const handleResize = () => {setIsDesktop(window.innerWidth > 768)};
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {window.removeEventListener('resize', handleResize)};
  }, []);

  useEffect(() => {
    if (!isDesktop) return;
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => {observer.disconnect()};
  }, [threshold, isDesktop]);

  if (!isDesktop) return <>{children}</>;

  return (
    <div ref={ref}>
      <Inner $isVisible={isVisible}>{children}</Inner>
    </div>
  );
};

export default FadeInOnScroll;